import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { register as registerSW, setupInstallPrompt } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality - DISABLED DURING DEVELOPMENT
// registerSW({
//   onSuccess: () => {
//     console.log('Service worker registered successfully');
//   },
//   onUpdate: () => {
//     console.log('New content available, please refresh');
//     // You could show a notification to the user here
//   },
// });

// Setup PWA install prompt
// setupInstallPrompt();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
